import Home from "../views/Home";

const routes = [
  {
    path: "/",
    component: Home,
    // meta: { requiresAuth: true, guest: false, mda: true },
  },
];

export default routes;
